import React from "react";
import Modal from '../Modal';
import GoalModal from './GoalModal';

const GoalOption = ({option, setActive, active, setCustomGoalAdded, customGoalAdded, initialActive, fireAmplitude, ampEventType, options, type}) => {

  const createAuthorsHubSelection = (option) => {
    let optionToUpdate = options[option]
    let data = {};
    if(!optionToUpdate) {
      optionToUpdate = "custom"
      data["custom_goal"] = option
    }
    data[type] = optionToUpdate;
    $.ajax({
      type: 'PUT',
      url: `/authors_hub_selection`,
      dataType: 'json',
      data: {authors_hub_selection: data},
      success: function(res) {
      }
    });
  }

  const handleClick = (option) => {
    if(option === 'Add your goal') {
      setCustomGoalAdded(true)
      setActive(initialActive)
      Modal.open({
        children: <GoalModal
        setActive={setActive}
        setCustomGoalAdded={setCustomGoalAdded}
        fireAmplitude={fireAmplitude}
        ampEventType={ampEventType}
        createAuthorsHubSelection={createAuthorsHubSelection}
      />})
    } else {
      createAuthorsHubSelection(option)
      fireAmplitude(ampEventType, {selection: option})
      setCustomGoalAdded(false)
      setActive(option)
    }
  }

  const handleChecked = (option) => {
    return option === active || (customGoalAdded && option === 'Add your goal')
  }

  return (
    <div className="goal-option" onClick={() => handleClick(option)}>
      <input className="checkbox" type="checkbox" checked={handleChecked(option)} readOnly/>
      {option}
    </div>
  )
}

export default GoalOption;
